export default __webpack_public_path__ + "static/media/discipline.2a1452af.png";